<ng-container *ngIf='!displayTooltip'>
  <mat-label>
    <label [for]='labelFor' class='dsp-color-text-neutral xs-semi-bold'>{{ fieldLabel }}</label>
  </mat-label>
</ng-container>

<ng-container *ngIf='displayTooltip'>
  <mat-label>
    <div class='field-label-tooltip-container'>
      <label [for]='labelFor' class='dsp-color-text-neutral xs-semi-bold'>{{ fieldLabel }}</label>
      <app-icon-tool-tip
        [matTooltipInfo]=matTooltipInfo
        [matTooltipPositionInfo]='matTooltipPositionInfo'
        style='height: 17px;'
      />
    </div>
  </mat-label>
</ng-container>
